import React from 'react'
import Header from '../../components/Header/Header';
import NavbarMenu from '../../components/NavbarMenu/NavbarMenu';
import Footer from '../../components/Footer/Footer';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import "./items.css";
import ItemsMenu from './ItemsMenu';
const Maxillo = () => {
  return (
    <div>
      <Header />
      <NavbarMenu />
      <ul class="centermiddledown breadcrumbs">
        <div class="bgground">
          <li><Link class="fas fa-home" to="/"></Link></li>
          <li><Link  to="/">Services</Link></li>
          <li>Maxillofacial Surgery</li>
        </div>
      </ul>
    <div className='heading text-center'>
      <h1>Maxillofacial Surgery</h1>


    </div>
        <Container className='item-container'>
            <Row>
                <Col md={8}>
                    <h2>MAXILLOFACIAL SURGERY</h2>
                    <h3>SIMPLE AND SURGICAL EXTRACTIONS</h3>
      <p>Dental extraction (also referred to as exodontia) is the removal of a tooth from the
mouth.</p>
<p>Extractions of impacted or problematic wisdom teeth are routinely performed, as
are extractions of some permanent teeth to make space for orthodontic treatment.
</p>
<h3>SINUS LIFT SURGERY
</h3>
<p>A maxillary sinus floor augmentation procedure (sometimes known informally as a
sinus-lift or sinus procedure) is a surgical procedure performed by an appropriately
trained dentist or dental specialist to increase the amount of bone in the posterior
maxilla, or upper jaw bone</p>
<div className='img-box'>
<img src="/servicesicons/image-026.jpg" alt="" className='img-fluid' />
</div>
                </Col>
                <Col md={4}>
                <ItemsMenu />
                </Col>
            </Row>
        </Container>
    <Footer />
    </div>
  )
}

export default Maxillo